var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_99_436)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M32.5833 15.3333H13.4167C9.18083 15.3333 5.75 18.7642 5.75 23C5.75 27.2358 9.18083 30.6667 13.4167 30.6667H32.5833C36.8192 30.6667 40.25 27.2358 40.25 23C40.25 18.7642 36.8192 15.3333 32.5833 15.3333ZM32.5833 28.75C29.4017 28.75 26.8333 26.1817 26.8333 23C26.8333 19.8183 29.4017 17.25 32.5833 17.25C35.765 17.25 38.3333 19.8183 38.3333 23C38.3333 26.1817 35.765 28.75 32.5833 28.75Z",
    fill: "url(#paint0_linear_99_436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5827 11.5H13.416C7.07185 11.5 1.91602 16.6558 1.91602 23C1.91602 29.3442 7.07185 34.5 13.416 34.5H32.5827C38.9268 34.5 44.0827 29.3442 44.0827 23C44.0827 16.6558 38.9268 11.5 32.5827 11.5ZM32.5827 30.6667H13.416C9.18018 30.6667 5.74935 27.2358 5.74935 23C5.74935 18.7642 9.18018 15.3333 13.416 15.3333H32.5827C36.8185 15.3333 40.2493 18.7642 40.2493 23C40.2493 27.2358 36.8185 30.6667 32.5827 30.6667ZM32.5827 17.25C29.401 17.25 26.8327 19.8183 26.8327 23C26.8327 26.1817 29.401 28.75 32.5827 28.75C35.7643 28.75 38.3327 26.1817 38.3327 23C38.3327 19.8183 35.7643 17.25 32.5827 17.25Z",
    fill: "url(#paint1_linear_99_436)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_99_436",
    x1: 23,
    y1: 15.3333,
    x2: 23,
    y2: 30.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9057E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC475D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC475D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_99_436",
    x1: 22.9993,
    y1: 11.5,
    x2: 22.9993,
    y2: 34.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9057E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC475D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC475D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_99_436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white",
    transform: "matrix(-1 0 0 1 46 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.f8e06dd059c6e6ce00320f513c6ea229.svg";
export { ForwardRef as ReactComponent };